import * as React from 'react';
import { cn } from '@/lib/utils';

export type WfDotTone = 'neutral' | 'run' | 'ok' | 'wait' | 'bad';

export interface WfDotProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Tom (wireframe .dot.run/.ok/.wait/.high). 'bad' = vermelho (.high). */
  tone?: WfDotTone;
  /** Animação de pulso (wireframe .live::before / @keyframes pulse). */
  pulse?: boolean;
}

/** Status dot 7px do wireframe (.dot + tons + pulse). */
export const WfDot = React.forwardRef<HTMLSpanElement, WfDotProps>(
  ({ tone = 'neutral', pulse = false, className, ...props }, ref) => (
    <span
      ref={ref}
      aria-hidden="true"
      className={cn(
        'wf-dot',
        tone !== 'neutral' && `wf-dot--${tone}`,
        pulse && 'wf-dot--pulse',
        className
      )}
      {...props}
    />
  )
);
WfDot.displayName = 'WfDot';
